import { useContext } from 'react';

import { AuthRecruiterContext } from '@/providers/AuthRecruiterProvider';

const useAuthRecruiter = () => useContext(AuthRecruiterContext);

export default useAuthRecruiter;
